import {bcfModel} from '../constants/bcf-report';
import {toReportFileNameDateAndTime} from './date-helpers';

export const isSupportedUnitAndType = (modelUnit, modelType) => {
  const {supportedModelUnits, supportedModelType} = bcfModel;
  return supportedModelUnits.includes(modelUnit) && supportedModelType.includes(modelType);
};

export const getFileName = (issue, showIssueNameInFileName, currentDocument) => {
  const currentDate = toReportFileNameDateAndTime(new Date());
  const {name: documentName, revision: documentVersion} = currentDocument ?? {};
  if (showIssueNameInFileName && issue) {
    return documentName
      ? `${issue.title} on ${documentName}-V${documentVersion} ${currentDate}`
      : `${issue.title} ${currentDate}`;
  }
  return `${documentName ?? ''}-V${documentVersion ?? ''} ${currentDate}`;
};
